import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ShieldCheckIcon, LockIcon, FileTextIcon, DumbbellIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { HERO_MOCKUP } from '../../data/content';
const BADGES = [{
  icon: FileTextIcon,
  label: 'Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-carbon" data-id="element-146">
      {/* Faded mockup background */}
      <div className="absolute inset-0 bg-cover bg-center opacity-25" style={{
      backgroundImage: `url(${HERO_MOCKUP})`
    }} aria-hidden="true" data-id="element-147" />
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(180deg, rgba(10,10,10,0.7) 0%, rgba(10,10,10,0.85) 60%, #0A0A0A 100%)'
    }} aria-hidden="true" data-id="element-148" />
      {/* Radial orange glow */}
      <div className="absolute left-1/2 top-1/3 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{
      background: 'radial-gradient(circle, rgba(255,107,0,0.22) 0%, rgba(255,107,0,0) 70%)'
    }} aria-hidden="true" data-id="element-149" />

      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-5 pb-20 pt-8 text-center sm:pb-28 sm:pt-12" data-id="element-150">
        {/* Brand wordmark centered in the flow */}
        <motion.span initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-8 inline-flex items-center gap-1.5" data-id="element-151">
          <span className="text-center font-heading text-[10px] font-extrabold uppercase tracking-[0.18em] text-soft" data-id="element-152">
            Cherub{' '}
            <span className="bg-gradient-to-r from-gold via-[#E6C766] to-gold bg-clip-text text-transparent" data-id="element-153">
              Agency
            </span>
            <span className="align-super text-[0.6em] text-gold" data-id="element-154">™</span>
          </span>
        </motion.span>
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="font-heading text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-soft sm:text-6xl" data-id="element-155">
          El Método del{' '}
          <span className="text-orange" data-id="element-156">Deportista Incansable</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="mt-8 mb-4 max-w-3xl" data-id="element-157">
          <img src="https://cdn.magicpatterns.com/uploads/vg954NhvYhTZPmsfs2au7W/04972d66-e812-4d76-8604-fc4e079f6cb9.png" alt="Megapack El Método del Deportista Incansable" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(255,107,0,0.2)]" data-id="element-158" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-4 max-w-2xl text-muted font-bold sm:text-xl text-[14px]" data-id="element-159">
          El sistema completo para recuperarte más rápido, entrenar más seguido
          y rendir al máximo durante años.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-160">
          {BADGES.map(({
          icon: Icon,
          label
        }) => <span key={label} className="flex items-center gap-2 text-sm text-muted" data-id="element-161">
              <Icon className="h-4 w-4 text-gold" data-id="element-162" />
              {label}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="mt-10 flex w-full justify-center" data-id="element-163">
          <CTAButton pulse data-id="element-164" />
        </motion.div>
      </div>
    </header>;
}